export default {
  pageTitle: 'Retubing Service',
  metaDescription: 'TEF provides retubing services to replace worn or damaged heat exchanger tubes, restoring thermal performance and extending equipment life.',
  sidebar: {
    heading: 'Maintenance And Reconditioning list',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reshell: 'Re-Shell',
    retubing: 'Re-Tubing',
  },
  title: 'Retubing',
  heading: 'Heat Exchanger Retubing and Tube Replacement Services',
  paragraph1: 'We specialize in retubing and replacing leaking tubes in heat exchangers, ensuring optimal performance and extended equipment life. Our services can be carried out at our fully equipped workshop or conveniently at your site, minimizing downtime and ensuring efficient repairs.',
  paragraph2: 'With a focus on precision and quality, our experienced team ensures seamless removal and installation of tubes, restoring your heat exchanger to peak functionality. Whether for routine maintenance or urgent repairs, we provide reliable solutions tailored to your needs.',
  steps: {
    step1: 'Dismantle Tube',
    step2: 'Cleaning Tube',
    step3: 'Removing Weld',
    step4: 'Pulling Tube',
    step5: 'Bevel Tube Hole',
    step6: 'Welding Tube',
  },
};
